import styled from 'styled-components'
import gigplanetTheme from '../../styles/gigplanetTheme'

export const ListItem = styled.li``

export const MenuSpacer = styled.hr`
  font-size: 1px;
  height: 1px;
  margin: 5px 0;
  background-color: ${gigplanetTheme.element.default.border};
  width: 100%;
  border: 0;
`
